<h2
    mat-dialog-title
    class="cut-long-text"
>
    @if (!consumerTabName() && !(consumerError() || subjectError())) {
    Neue
    }
    Übungsaufgabe für <span class="name"><pixl-lang
            [key]="key"
            [keySuffix]="getExerciseSubKind()"
        ></pixl-lang></span>
</h2>
<mat-divider></mat-divider>
<br />
<mat-dialog-content>
    <mat-tab-group id="tab-group">
        <form [formGroup]="formGroup">
            <mat-tab label="{{ 'edit' | transloco }}">
                <br />
                <div>
                    <mat-form-field>
                        <mat-label>{{ "consumer" | transloco }}</mat-label>
                        <mat-select
                            formControlName="consumers"
                            required
                            [compareWith]="compareConsumer"
                            (selectionChange)="consumerError.set(false)"
                        >
                            @for (consumer of consumers$ | async; track consumer.id) {
                            <mat-option [value]="consumer.id">{{
                                consumer.name
                                }}</mat-option>
                            }
                        </mat-select>
                        @if (consumerError()) {
                        <mat-error>{{ getConsumerError() }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>{{ "subject_job" | transloco }}</mat-label>
                        <mat-select
                            formControlName="subjects"
                            required
                            (selectionChange)="subjectError.set(false)"
                        >
                            @for (subject of subjects$ | async; track subject.id) {
                            <mat-option [value]="subject.id">{{
                                subject.name
                                }}</mat-option>
                            }
                        </mat-select>
                        @if (subjectError()) {
                        <mat-error>{{ getSubjectError() }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>{{ "name" | transloco }}</mat-label>
                        <input
                            matInput
                            type="text"
                            required
                            placeholder=""
                            formControlName="name"
                            name="name"
                        />
                        <mat-error>{{ checkName(formGroup.controls["name"]) }}</mat-error>
                    </mat-form-field>
                </div>
                <pixl-state-cb
                    [required]="true"
                    [initValue]="this.data?.approval || ''"
                    (onStateChange)="statusChanged($event)"
                />
                <mat-label>{{ "globally_locked" | transloco }}&nbsp;</mat-label>
                <mat-slide-toggle formControlName="copyRestricted"></mat-slide-toggle>
                <div>
                    <h3>{{ "sequences" | transloco }}</h3>
                    {{ "no_sequences" | transloco }}
                </div>
            </mat-tab>
            @if (consumer()) {
            <mat-tab [label]="consumerTabName() || 'Metadaten'">
                <mat-dialog-content class="grid">
                    <pixl-object-consumer-metadata
                        [parentForm]="formGroup"
                        [objectType]="'exercise'"
                    ></pixl-object-consumer-metadata>
                </mat-dialog-content>
            </mat-tab>
            }
        </form>
    </mat-tab-group>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button
        mat-raised-button
        (click)="onCancel()"
    >{{ "abort" | transloco }}</button>
    <button
        mat-raised-button
        (click)="onSave()"
    >{{ "save" | transloco }}</button>
</mat-dialog-actions>